import React, { useEffect, useState } from "react";
import ApiServices from "../../services/apiServices";
import "./index.css";
import { toast } from "react-toastify";
import { useLoad } from "../../context/Load";
import { useNavigate } from "react-router";
import Tabela from "../../Components/Tabela";
export default function Validador() {
  const [importacao, setImportacao] = useState({
    campanha: "",
    importacao: "",
    arquivoAnexado: "",
  });

  const [filtroColuna, setFiltroColuna] = useState([]);
  const [idCampanha, setIdCampanha] = useState("");
  const [pesquisar, setPesquisar] = useState("");
  const [trava, setTrava] = useState(false);
  const [listarApuracao, setListarApuracao] = useState({
    items: [
      {
        data: "2024-01-10 14:30:00",
        adminNome: "João Silva (MOKADO)",
        nomeArquivo: "importacao_janeiro.xlsx",
        apuracaoId: 1,
      },
      {
        data: "2024-01-09 10:15:00",
        adminNome: "Maria Santos (MOKADO)",
        nomeArquivo: "dados_dezembro.xlsx",
        apuracaoId: 2,
      },
    ],
    totalCount: 2,
  });
  const navigate = useNavigate();
  const { load, setLoad } = useLoad();
  const [paginacao, setPaginacao] = useState({
    pageIndex: 1,
    pageSize: 10,
  });

  const [tipoValidacao, setTipoValidacao] = useState([
    {
      nome: "vendedor",
      id: 1,
    },
    {
      nome: "gerente",
      id: 2,
    },
  ]);
  const colunas = [
    {
      accessorKey: "data",
      header: "Data/hora da importação",
      muiTableHeadCellProps: { align: "left" },
      muiTableBodyCellProps: { align: "left" },
    },
    {
      accessorKey: "adminNome",
      header: "Nome do usuário Admin",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      accessorKey: "nomeArquivo",
      header: "Nome do arquivo importado",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      id: "mrt-custom-actions",
      header: "",
      Cell: ({ row }) => (
        <>
          <div className="d-flex flex-row justify-content-end">
            <button
              className="btn btn-outline-secondary"
              style={{ minWidth: 100 }}
              disabled={trava}
              onClick={() => {
                setTrava(true);
                fnBotaoExportar(row.original.apuracaoId);
              }}
            >
              Exportar
            </button>
          </div>
        </>
      ),
      muiTableHeadCellProps: { align: "right" },
      muiTableBodyCellProps: { align: "right" },
      size: 150,
    },
  ];

  async function fnExpurgoGerente() {
    setLoad(true);
    try {
      let response = await ApiServices.apiDownloadXlsxGET(
        "importacao/validador-apuracao/gerente/expurgo"
      );
    } catch (err) {
      console.error("err", err);
      setTrava(false);
    } finally {
      setLoad(false);
    }
  }
  async function fnExpurgoVendedor() {
    setLoad(true);
    try {
      let response = await ApiServices.apiDownloadXlsxGET(
        "importacao/validador-apuracao/vendedor/expurgo"
      );
    } catch (err) {
      console.error("err", err);
      setTrava(false);
    } finally {
      setLoad(false);
    }
  }

  async function fnBotaoExportar(id) {
    setLoad(true);
    try {
      let response = await ApiServices.apiDownloadXlsxGET(
        `validador/${id}/exportar`,
        "validador"
      );
      if (response.statusCode == 200) {
        fnListarValidador();
      } else {
        toast.error(response.message);
      }
      setTrava(false);
    } catch (err) {
      console.error("err", err);
      setTrava(false);
    } finally {
      setLoad(false);
    }
  }

  async function fnListarValidador() {
    setLoad(true);

    const parametros = {
      q: pesquisar || "",
      page: paginacao.pageIndex || "1",
      pageSize: paginacao.pageSize || "",
      campanhaId: idCampanha || "",
    };

    try {
      const queryString = new URLSearchParams(parametros).toString();
      let response = await ApiServices.apiGet(
        importacao.tipoValidacao == 2
          ? "importacao/gerente"
          : "importacao/vendedor"
      );

      if (response.statusCode == 200) {
        setListarApuracao(response.data);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    fnListarValidador();
  }, [importacao.tipoValidacao]);

  return (
    <>
      <div className="row">
        <span className="tituloPagina">VALIDADOR DE APURAÇÃO</span>
      </div>

      <div className="row d-flex align-items-end mb-3">
        <div className="col-md-3">
          <form autoComplete="off">
            <br />
            <label>Tipo de validação</label>
            <select
              className="form-select"
              value={importacao.tipoValidacao}
              onChange={(e) =>
                setImportacao({ ...importacao, tipoValidacao: e.target.value })
              }
            >
              {tipoValidacao.map((item) => (
                <option value={item.id}>{item.nome}</option>
              ))}
            </select>
          </form>
        </div>

        <div className="col-md-2">
          <button
            className="btn btn-primary"
            onClick={() => fnListarValidador()}
          >
            Buscar
          </button>
        </div>
      </div>

      <Tabela
        colunas={colunas}
        dados={listarApuracao.items || []}
        paginacaoPelaApi={true}
        totalLinhas={listarApuracao?.totalCount}
        setPaginacao={setPaginacao}
        paginacao={paginacao}
        buscaGlobal={true}
        setPesquisar={(e) => {
          setPesquisar(e);
        }}
        filtroColuna={filtroColuna}
        setFiltroColuna={setFiltroColuna}
        buscaColunas={false}
      />
    </>
  );
}
